import { Stack } from "types/generated";
import { useBulkDisableStack } from "shared/Stack/useDisableStack";
import useCanDisableStack from "shared/Stack/access/useCanDisableStack";

import { StackBulkActions } from "../types";
import { BULK_ACTION_NAMES, BULK_ACTION_RESULTS_TITLE } from "../constants";

const useDisableStackBulkAction = () => {
  const [disableStack] = useBulkDisableStack();

  const canDisableStack = useCanDisableStack();

  return {
    key: StackBulkActions.Disable,
    title: BULK_ACTION_NAMES[StackBulkActions.Disable],
    resultTitle: BULK_ACTION_RESULTS_TITLE[StackBulkActions.Disable],
    condition: (stack: Stack) => canDisableStack(stack),
    mutation: (stack: Stack) => disableStack({ id: stack.id }),
  };
};

export default useDisableStackBulkAction;
